import z from "zod";
import { US_FORMAT_CONFIGURATION } from "./lib.js";
const CAValidationSchema = z.object({
  zipCode: z.string().regex(
    /^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z](?:[ -]?[0-9][ABCEGHJ-NPRSTV-Z][0-9])?$/i
  )
});
const CANADA_FORMAT_CONFIGURATION = {
  inputMaskConfiguration: {
    patterns: ["a0a 0a0"],
    prepare: (str) => str.toUpperCase()
  },
  maxCharacterLimit: 7,
  validationSchema: CAValidationSchema
};
const AKAMAI_ZIP_CODE_LOCALE_VALIDATION_CONFIGURATION = {
  "en-ca": CANADA_FORMAT_CONFIGURATION,
  "en-us": US_FORMAT_CONFIGURATION,
  "fr-ca": CANADA_FORMAT_CONFIGURATION
};
export {
  AKAMAI_ZIP_CODE_LOCALE_VALIDATION_CONFIGURATION
};
